__turbopack_context__.v({
  "root": "hom8iW_root",
  "vaLink": "hom8iW_vaLink",
  "vaLinkArrow": "hom8iW_vaLinkArrow",
  "vaLogo": "hom8iW_vaLogo",
});
